import React from 'react';

function TitlePage(props: any) {
  return (<div className="title-page"><h1 className="text--center bold">{props.name}</h1></div>);
}

export default TitlePage;

